import React from 'react';
import styled from 'styled-components/macro';
import Placeholder from '@tovia/man-ui/lib/components/Placeholder/Placeholder';

export const ImageViewerPlaceholder = () => {
  const { Image } = Placeholder;

  return (
    <Wrap>
      <Image />
    </Wrap>
  );
};

const Wrap = styled(Placeholder)`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .image {
    width: 500px;
    height: 80vh;
    max-height: 600px;
    padding-top: 0;
  }
`;
